import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-border bg-cream py-10" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-6 px-5 sm:flex-row sm:items-center sm:px-8">
        <div className="flex items-center gap-3">
          <img src="/bootrise-logo.png" alt="BootRise" className="h-8 w-auto" />
          <span className="text-sm text-ink-muted">
            featuring Lint · <span className="font-hand text-lg text-brand">Same idea. Better questions.</span>
          </span>
        </div>
        <div className="flex flex-wrap items-center gap-5 text-sm text-ink-muted">
          <Link to="/demo" className="transition-colors hover:text-navy" data-testid="footer-demo-link">
            Interactive preview
          </Link>
          <a href="#waitlist" className="transition-colors hover:text-navy" data-testid="footer-book-demo-link">
            Book a demo
          </a>
          <span>© {new Date().getFullYear()} BootRise</span>
        </div>
      </div>
    </footer>
  );
}
